import { render, staticRenderFns } from "./IconLead.vue?vue&type=template&id=6e8a0a4b&scoped=true"
import script from "./IconLead.vue?vue&type=script&lang=js"
export * from "./IconLead.vue?vue&type=script&lang=js"
import style0 from "./IconLead.vue?vue&type=style&index=0&id=6e8a0a4b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e8a0a4b",
  null
  
)

export default component.exports